import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import i18next from 'i18next';
import { LogInIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { ORIGINAL_PATH_STORAGE_KEY } from '@/components/auth/AuthContext';
import { auth } from '@/components/auth/firebase';
import { Button } from '@/components/ui/button';

const SignIn = () => {
  const navigate = useNavigate();

  const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: 'select_account'
    });

    try {
      await signInWithPopup(auth, provider);

      const originalPath = sessionStorage.getItem(ORIGINAL_PATH_STORAGE_KEY);
      if (!!originalPath) {
        sessionStorage.removeItem(ORIGINAL_PATH_STORAGE_KEY);
        navigate(originalPath);
      } else {
        navigate('/mission-reports/new');
      }
    } catch (err) {
      console.error('Error during Google sign-in:', err);
    }
  };

  return (
    <div className="flex items-center justify-center h-full">
      <Button size="lg" onClick={signInWithGoogle}>
        <span>{i18next.t('sign_in.sign_in_with_google')}</span>
        <LogInIcon className="ml-auto h-4 w-4" />
      </Button>
    </div>
  );
};

export default SignIn;
